<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				{{ unit.name }}
			</v-card-title>
			<v-divider></v-divider>
		</v-card>
	</v-container>
</template>

<script>
	export default {
		props: ["unit"],
	};
</script>